import React from 'react'

import { Link } from 'react-router-dom';

import '../css/tabresponsive.css';


import HorizontalTabs from '../components/HorizontalTabs';

function ibdphandbook() {

  const tabs = [
    { title: 'IBDP Handbooks', content: () => <div>
    
    <div className='cam-lower-sec'>
   <h1 className='title'>IBDP Written Curriculum Handbook</h1>
   </div>
   <div className='idbp-handbook-list'>
    <div className='handbook-box'>
    <Link  to="../pdf/ibdp handbook/IBDP_HANDBOOK_2025-27.pdf"
        target="_blank"
        rel="noopener noreferrer"
    >
      <div className='handbook-img'>
      <img src='../img/ibdp-handbook/handbook-2022-24.webp'/>
      </div>
      2025-27
      
      </Link>
    </div>
  
    <div className='handbook-box'>
    <Link  to="../pdf/ibdp handbook/IBDP_HANDBOOK_2024-26.pdf"
        target="_blank"
        rel="noopener noreferrer"
    >
      <div className='handbook-img'>
      <img src='../img/ibdp-handbook/handbook-2022-24.webp'/>
      </div>
      2024-26
      
      </Link>
    </div>

   
  



   </div>



      
    </div> },
    { title: 'CAS Handbooks', content: () => <div>
     <div className='cam-lower-sec'>
   <h1 className='title'>CAS Handbooks</h1>
   </div>
   <div className='idbp-handbook-list'>
   
    <div className='handbook-box'>
    <Link  to="../pdf/cas-handbook/Final CAS Handbook-(2026-2028).pdf"
        target="_blank"
        rel="noopener noreferrer"
    >
      <div className='handbook-img'>
      <img src='../img/ibdp-cas-handbook/cas-hand-book.webp'/>
      </div>
    2026-2028
    </Link>
    </div>
    <div className='handbook-box'>
    <Link  to="../pdf/cas-handbook/Final CAS Handbook-(2024-2026).pdf"
        target="_blank"
        rel="noopener noreferrer"
    >
      <div className='handbook-img'>
      <img src='../img/ibdp-cas-handbook/cas-hand-book.webp'/>
      </div>
    2024-26
    </Link>
    </div>
    <div className='handbook-box'>
    <Link  to="../pdf/cas-handbook/Final CAS Handbook-(2025-2027).pdf"
        target="_blank"
        rel="noopener noreferrer"
    >
      <div className='handbook-img'>
      <img src='../img/ibdp-cas-handbook/cas-hand-book.webp'/>
      </div>
    2025-27
    </Link>


    </div>

 

  

   </div>

    </div> },
    { title: 'TOK Handbooks', content: () => <div>
        <div className='cam-lower-sec'>
   <h1 className='title'>TOK Handbooks</h1>
   </div>
   <div className='idbp-handbook-list'>
    <div className='handbook-box'>
    <Link  to="../pdf/tok-handbook/TOK HAND BOOK 2026-28.pdf"
        target="_blank"
        rel="noopener noreferrer"
    >
      <div className='handbook-img'>
      <img src='../img/tok-handbook/tok-handbook.webp'/>
      </div>
     2026-28</Link>
    </div>
    <div className='handbook-box'>
    <Link  to="../pdf/tok-handbook/TOK HAND BOOK 2024-26.pdf"
        target="_blank"
        rel="noopener noreferrer"
    >
      <div className='handbook-img'>
      <img src='../img/tok-handbook/tok-handbook.webp'/>
      </div>
     2024-26</Link>
    </div>
    <div className='handbook-box'>
    <Link  to="../pdf/tok-handbook/TOK HAND BOOK 2025-27.pdf"
        target="_blank"
        rel="noopener noreferrer"
    >
      <div className='handbook-img'>
      <img src='../img/tok-handbook/tok-handbook.webp'/>
      </div>
     2025-27</Link>


    </div>



  
   
   

   </div>


  


    </div> },
    { title: 'EE Handbooks', content: () => <div>

<div className='cam-lower-sec'>
   <h1 className='title'>EE Handbooks</h1>
   </div>
   <div className='idbp-handbook-list'>
    <div className='handbook-box'>
    <Link  to="../pdf/ee-handbook/EE_Student_Guide_2027.pdf"
        target="_blank"
        rel="noopener noreferrer"
    >
      <div className='handbook-img'>
      <img src='../img/ee-handbook/ee-handbook.webp'/>
      </div>
     2027</Link>
    </div>
    <div className='handbook-box'>
    <Link  to="../pdf/ee-handbook/EXTENDED-ESSAY-2026-28.pdf"
        target="_blank"
        rel="noopener noreferrer"
    >
      <div className='handbook-img'>
      <img src='../img/ee-handbook/ee-handbook.webp'/>
      </div>
     2026-28</Link>
    </div>
    <div className='handbook-box'>
    <Link  to="../pdf/ee-handbook/EXTENDED-ESSAY-2024-26.pdf"
        target="_blank"
        rel="noopener noreferrer"
    >
      <div className='handbook-img'>
      <img src='../img/ee-handbook/ee-handbook.webp'/>
      </div>
     2024-26</Link>
    </div>
    <div className='handbook-box'>
    <Link  to="../pdf/ee-handbook/EXTENDED-ESSAY-2025-27.pdf"
        target="_blank"
        rel="noopener noreferrer"
    >
      <div className='handbook-img'>
      <img src='../img/ee-handbook/ee-handbook.webp'/>
      </div>
     2025-27</Link>


    </div>

 
 



   </div>


    </div> },
  
  ];
  return (
    <div>
    <div className='ibdp-hero-sec'>
        <img src='newimg/Student-Council-Program.webp'/>

      </div>
      <div className='igcse-data'>
        <HorizontalTabs tabs={tabs} />
    </div>
    </div>
  )
}

export default ibdphandbook
